import {
    GET_MONTHLY_DELIVERYMAN_UNIQUE_SHOPS_REPORT,
} from '../../../../Types'

const MonthlyDeliverymanUniqueShopsReportReducer = (state = [], action) => {
    switch (action.type) {
        case GET_MONTHLY_DELIVERYMAN_UNIQUE_SHOPS_REPORT:
            return action.payload
        default:
            return state
    }
}
export default MonthlyDeliverymanUniqueShopsReportReducer